import MultiAccessKamList from './MultiAccessKamList';

export default MultiAccessKamList;
// export { default } from './MultiAccessKamList';
